import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  selectProduct: new analytics.Event({
    name: 'Product Selected',
    description: 'Merchant selects product(s)',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['productId'],
    userAttributes: ['productId'],
  }),
  clickPricingTable: new analytics.Event({
    name: 'Pricing Table Clicked',
    description: 'Merchant cliked to open the Pricing Table',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
  }),
};
